import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import React from 'react';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import { P2GCdnIcon } from '@parcel2go/peacock-legacy-core/dist/icons';
import SvgLink from '@parcel2go/peacock-legacy-core/dist/icons/svg/Link';

interface props {
  children: string;
}

export default function InstructionsFooter(props: props) {
  return (
    <P2GGrid container wrap="nowrap" spacing={2} alignItems="center">
      <P2GGrid item flexShrink={1}>
        <P2GCdnIcon size="sm">
          <SvgLink />
        </P2GCdnIcon>
      </P2GGrid>
      <P2GGrid item flexGrow={1}>
        <P2GText component="p" variant="body2">
          {props.children}
        </P2GText>
      </P2GGrid>
    </P2GGrid>
  );
}
